import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { ProjectExperienceConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ProjectExperienceGroupService } from './api/projectExperienceGroup.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ProjectExperienceApiModule {
    public static forRoot(configurationFactory: () => ProjectExperienceConfiguration): ModuleWithProviders<ProjectExperienceApiModule> {
        return {
            ngModule: ProjectExperienceApiModule,
            providers: [ { provide: ProjectExperienceConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ProjectExperienceApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ProjectExperienceApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
